// src/components/BotaoFatura.jsx
import React from 'react';
import { useHttpClient } from '../hooks/useHttpClient';
import { usePreventDoubleClick } from '../hooks/usePreventDoubleClick';
import { useNotificacoes } from '../hooks/useNotificacoes';

import './BotaoFatura.module.css';

function BotaoFatura({ idConsumo, className, children }) {
    const { post } = useHttpClient();
    const { exibirErro, exibirSucesso } = useNotificacoes();
    const [safeGerar, isGerando] = usePreventDoubleClick(gerarFatura);

    async function gerarFatura() {
        try {
            // fullResponse: true para termos acesso a headers
            const res = await post(
                `/hello-sol/boletos/fatura/${idConsumo}`,
                null,
                { responseType: 'blob', fullResponse: true }
            );

            const contentType = res.headers.get('content-type') ||
                res.headers.get('Content-Type') ||
                '';
            // se não for PDF, é JSON de erro!
            if (!contentType.includes('application/pdf')) {
                // converte o blob para texto e depois para JSON
                const text = await res.blob().then(b => b.text());
                let err;
                try {
                    err = JSON.parse(text);
                } catch {
                    err = { message: text };
                }
                throw new Error(err.message || 'Erro ao gerar fatura');
            }

            // extração robusta do filename
            const cd = res.headers.get('content-disposition') || '';
            let filename = `fatura_${idConsumo}.pdf`;
            let match = cd.match(/filename\*\s*=\s*(?:UTF-8'')?["']?([^;"']+)["']?/i);
            if (!match) {
                match = cd.match(/filename\s*=\s*["']?([^;"';]+)["']?/i);
            }
            if (match && match[1]) {
                filename = decodeURIComponent(match[1]);
            }

            // é PDF: baixa o blob
            const blob = await res.blob();
            if (!blob || blob.size === 0) {
                throw new Error('Arquivo PDF vazio');
            }

            const objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(objectUrl);

            exibirSucesso('Fatura gerada com sucesso');
        } catch (err) {
            exibirErro(err.message || 'Falha ao gerar a fatura');
        }
    }

    return (
        <button
            type="button"
            className={className}
            onClick={safeGerar}
            disabled={isGerando}
            style={{
                background: 'none',
                color: 'blue',
                border: 'none',
                padding: 0,
                margin: 0,
                cursor: isGerando ? 'wait' : 'pointer'
            }}
        >
            {isGerando ? '…' : children}
        </button>
    );
}

export default BotaoFatura;
